import { ServiceIcon } from '../icons/ServiceIcon';
import { CustomFormattedMessage } from '../../i18n/i18n';
import { SERVICE_TO_TRANSLATION_KEY } from '../../i18n/enumMappings';
import { ServiceType } from '../../codegen/vehicles';

export type ServiceRepresentationSize = 'medium' | 'large';

const iconClassesBySize: { [k in ServiceRepresentationSize]: string } = {
  medium: 'text-size-18 margin-right-5',
  large: 'text-size-20 margin-right-10',
};

export const ServiceRepresentation = ({
  serviceType,
  showServiceName = true,
  representationSize = 'medium',
  additionalClassName,
  isActive = true,
}: {
  serviceType: ServiceType;
  showServiceName?: boolean;
  representationSize?: ServiceRepresentationSize;
  additionalClassName?: string;
  isActive?: boolean;
}) => {
  const className = `display-flex gap-5 align-items-center ${additionalClassName ?? ''}`;
  const textColor = isActive ? 'text-color-dark' : 'text-color-light';
  return (
    <div className={className}>
      <ServiceIcon
        service={serviceType}
        className={`${iconClassesBySize[representationSize]} ${textColor}`}
      />
      {showServiceName && (
        <span className="ellipsis-1">
          <CustomFormattedMessage
            id={SERVICE_TO_TRANSLATION_KEY[serviceType]}
          />
        </span>
      )}
    </div>
  );
};
